export default __webpack_public_path__ + "static/media/dmd-gold-fa.54391afa.svg";